// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  margin: 12px 0 4px 0;
}

.lightweight {
  width: 100%;
  min-width: 250px;
  border: none;
  background-color: #f0f0f0;
  font-size: 14px;
  height: 36px;
  padding: 8px;
  box-sizing: border-box;
}

.lightweight:disabled {
  background-color: #c8c8c8;
}

.validation-error .outline-validation-background-lay,
.validation-error .fill-validation-background-lay {
  position: absolute;
  background-color: #ffc8c8;
  z-index: -1;
}
.validation-error .outline-validation-background-lay {
  top: 10px;
  right: -5px;
  bottom: 10px;
  left: -5px;
  border-radius: 2px;
}
.validation-error .fill-validation-background-lay {
  top: 0;
  right: -16px;
  bottom: 0;
  left: -16px;
  border-radius: 2px 2px 0 0;
}
.validation-error .outline-validation-background-lay.picker {
  right: -41px;
}
.validation-error .fill-validation-background-lay.picker {
  right: -52px;
}

.validation-warning .outline-validation-background-lay,
.validation-warning .fill-validation-background-lay {
  position: absolute;
  background-color: #fff8a0;
  z-index: -1;
}
.validation-warning .outline-validation-background-lay {
  top: 10px;
  right: -5px;
  bottom: 10px;
  left: -5px;
  border-radius: 2px;
}
.validation-warning .fill-validation-background-lay {
  top: 0;
  right: -16px;
  bottom: 0;
  left: -16px;
  border-radius: 2px 2px 0 0;
}
.validation-warning .outline-validation-background-lay.picker {
  right: -41px;
}
.validation-warning .fill-validation-background-lay.picker {
  right: -52px;
}

.validation-notice .outline-validation-background-lay,
.validation-notice .fill-validation-background-lay {
  position: absolute;
  background-color: green;
  z-index: -1;
}
.validation-notice .outline-validation-background-lay {
  top: 10px;
  right: -5px;
  bottom: 10px;
  left: -5px;
  border-radius: 2px;
}
.validation-notice .fill-validation-background-lay {
  top: 0;
  right: -16px;
  bottom: 0;
  left: -16px;
  border-radius: 2px 2px 0 0;
}
.validation-notice .outline-validation-background-lay.picker {
  right: -41px;
}
.validation-notice .fill-validation-background-lay.picker {
  right: -52px;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/base/object-input/object-input.component.scss"],"names":[],"mappings":"AAiCA;EACI,oBAAA;AAhCJ;;AAmCA;EACI,WAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;AAhCJ;;AAmCA;EACI,yBAAA;AAhCJ;;AAhBI;;EAEI,kBAAA;EACA,yBAAA;EACA,WAAA;AAmBR;AAhBI;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AAkBR;AAfI;EACI,MAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;AAiBR;AAdI;EACI,YAAA;AAgBR;AAbI;EACI,YAAA;AAeR;;AA3CI;;EAEI,kBAAA;EACA,yBAAA;EACA,WAAA;AA8CR;AA3CI;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AA6CR;AA1CI;EACI,MAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;AA4CR;AAzCI;EACI,YAAA;AA2CR;AAxCI;EACI,YAAA;AA0CR;;AAtEI;;EAEI,kBAAA;EACA,uBAAA;EACA,WAAA;AAyER;AAtEI;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AAwER;AArEI;EACI,MAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;AAuER;AApEI;EACI,YAAA;AAsER;AAnEI;EACI,YAAA;AAqER","sourcesContent":["@mixin validationBackgroundLay($color) {\n    .outline-validation-background-lay,\n    .fill-validation-background-lay {\n        position: absolute;\n        background-color: #{$color};\n        z-index: -1;\n    }\n\n    .outline-validation-background-lay {\n        top: 10px;\n        right: -5px;\n        bottom: 10px;\n        left: -5px;\n        border-radius: 2px;\n    }\n\n    .fill-validation-background-lay {\n        top: 0;\n        right: -16px;\n        bottom: 0;\n        left: -16px;\n        border-radius: 2px 2px 0 0;\n    }\n\n    .outline-validation-background-lay.picker {\n        right: -41px;\n    }\n\n    .fill-validation-background-lay.picker {\n        right: -52px;\n    }\n}\n\np {\n    margin: 12px 0 4px 0;\n}\n\n.lightweight {\n    width: 100%;\n    min-width: 250px;\n    border: none;\n    background-color: #f0f0f0;\n    font-size: 14px;\n    height: 36px;\n    padding: 8px;\n    box-sizing: border-box;\n}\n\n.lightweight:disabled {\n    background-color: #c8c8c8;\n}\n\n.validation-error {\n    @include validationBackgroundLay(#ffc8c8);\n}\n\n.validation-warning {\n    @include validationBackgroundLay(#fff8a0);\n}\n\n.validation-notice {\n    @include validationBackgroundLay(green);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
